import BlankContent from '@components/blank/BlankContent';
import Column from '@components/Column';
import styled from '@emotion/styled';

import usePointCards from './hooks/usePointCards';
import PointLog from './PointLog';

function PointLogs() {
    const pointCards = usePointCards();
    return (
        <Container fullWidth
            spacing={16} >
            {(pointCards?.length === 0) && (
                <BlankContent/>
            ) }
            {pointCards?.map((pointCard) => (
                <PointLog pointCard={pointCard}
                    key={pointCard.shopId}
                />))}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 36px 44px 184px;
`;

export default PointLogs;
